<template>
    <div class="hidden">
        <slot></slot>
    </div>
</template>

<script>
/*
Javascript based transition using velocity.
CSS transition has some stagering and suprisingly not as smooth as this.
*/
import Vel from 'velocity-animate'

export default {
    name: 'slide',
    props: {
        show: Boolean,
        duration: {
            type: Number,
            default: 350
        }
    },
    watch: {
        show(state) {
            if (state) {
                Vel(this.$el, 'slideDown', {
                    duration: this.duration,
                    complete: () => {
                        this.$emit('done')
                    }
                })
            } else {
                Vel(this.$el, 'slideUp', {
                    duration: this.duration,
                    complete: () => {
                        this.$emit('done')
                    }
                })
            }
        }
    },
}
</script>
